import axios from 'axios';

export interface CepResponse {
  erro?: string | boolean;
  cep: string;
  logradouro: string;
  complemento: string;
  unidade?: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado?: string;
  regiao?: string;
  ibge: string;
  gia?: string;
  ddd?: string;
  siafi?: string;
}

export interface CepLookupResult {
  cep: string;
  logradouro: string;
  complemento: string;
  unidade?: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
  regiao?: string;
  ibge: string;
  gia?: string;
  ddd?: string;
  siafi?: string;
}

/**
 * Looks up CEP information using ViaCEP first, then OpenCEP as fallback
 * @param zipCode - The CEP to lookup (with or without formatting)
 * @returns Promise<CepLookupResult> - Standardized CEP data
 * @throws Error if CEP is not found in both services
 */
export const lookupCep = async (zipCode: string): Promise<CepLookupResult> => {
  const cleanZipCode = zipCode.replace(/\D/g, ''); // Remove all non-digits

  if (cleanZipCode.length !== 8) {
    throw new Error('CEP deve ter 8 dígitos');
  }

  // Try ViaCEP first
  try {
    const viaCepResponse = await axios
      .get<CepResponse>(`https://viacep.com.br/ws/${cleanZipCode}/json/`)
      .then((response) => response.data);

    if (viaCepResponse.erro !== 'true' && viaCepResponse.erro !== true) {
      return {
        cep: viaCepResponse.cep,
        logradouro: viaCepResponse.logradouro,
        complemento: viaCepResponse.complemento,
        unidade: viaCepResponse.unidade,
        bairro: viaCepResponse.bairro,
        localidade: viaCepResponse.localidade,
        uf: viaCepResponse.uf,
        estado: viaCepResponse.estado || viaCepResponse.uf,
        regiao: viaCepResponse.regiao,
        ibge: viaCepResponse.ibge,
        gia: viaCepResponse.gia,
        ddd: viaCepResponse.ddd,
        siafi: viaCepResponse.siafi,
      };
    }
  } catch (error) {
    console.warn('ViaCEP failed, trying OpenCEP:', error);
  }

  // Try OpenCEP as fallback
  try {
    const openCepResponse = await axios
      .get<CepResponse>(`https://opencep.com/v1/${cleanZipCode}`)
      .then((response) => response.data);

    if (openCepResponse.erro !== true && openCepResponse.erro !== 'true') {
      return {
        cep: openCepResponse.cep,
        logradouro: openCepResponse.logradouro,
        complemento: openCepResponse.complemento,
        unidade: openCepResponse.unidade,
        bairro: openCepResponse.bairro,
        localidade: openCepResponse.localidade,
        uf: openCepResponse.uf,
        estado: openCepResponse.estado || openCepResponse.uf,
        regiao: openCepResponse.regiao,
        ibge: openCepResponse.ibge,
        gia: openCepResponse.gia,
        ddd: openCepResponse.ddd,
        siafi: openCepResponse.siafi,
      };
    }
  } catch (error) {
    console.warn('OpenCEP also failed:', error);
  }

  throw new Error('CEP não encontrado');
};







